import React from "react";
import { Link } from "react-router-dom";

const SignupAgreementNote = () => (
  <div className="space-y-2">
    <p className="text-xs text-brand-muted leading-relaxed">
      By signing up for this tournament, you agree to the{" "}
      <Link to="/terms-of-service" className="underline text-brand-gold-ink">
        Terms of Service
      </Link>{" "}
      and the{" "}
      <Link to="/refund-policy" className="underline text-brand-gold-ink">
        Refund policy
      </Link>
      .
    </p>
    <p className="text-xs text-brand-muted leading-relaxed">
      Your squads are reserved. You have 24 hours to complete your signup.
    </p>
  </div>
);

export default SignupAgreementNote;
